import { render, staticRenderFns } from "./CosignAboutApplication.vue?vue&type=template&id=6c0fb99c&"
import script from "./CosignAboutApplication.vue?vue&type=script&lang=js&"
export * from "./CosignAboutApplication.vue?vue&type=script&lang=js&"
import style0 from "./CosignAboutApplication.vue?vue&type=style&index=0&id=6c0fb99c&prod&lang=scss&media=screen&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports